// extracted by mini-css-extract-plugin
export default {"displayContainer":"SalonBackground_displayContainer__x8Z3A"};